"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const with_collapse_1 = require("../../molecules/with-collapse");
const TableTitle_1 = __importDefault(require("./TableTitle"));
const react_i18next_1 = require("react-i18next");
const tags_1 = require("../../atoms/tags");
const typography_1 = require("../../shared/typography");
const checkProgressValue_1 = __importDefault(require("./checkProgressValue"));
const TableHeader_1 = require("./TableHeader");
const fixDayNumber = (dayIdx, startDay) => {
    const sum = dayIdx + startDay;
    return sum >= 7 ? sum - 7 : sum;
};
const fillEmptyValues = (values) => {
    const copy = [...values];
    const fakeDataArray = new Array(7 - copy.length).fill(" ");
    copy.splice(0, 0, ...fakeDataArray);
    return copy;
};
const RowItem = ({ value }) => {
    if (value === " ")
        return (0, jsx_runtime_1.jsx)("div", {}, void 0);
    return ((0, jsx_runtime_1.jsx)(Item, { children: (0, jsx_runtime_1.jsx)(tags_1.Tag, { variant: "silver", children: value || "-" }, void 0) }, void 0));
};
const renderValues = (valuesMap, days, startDay, getDateFns, isProgress) => {
    const elements = [];
    for (const [key, values] of valuesMap.entries()) {
        const fixedValues = fillEmptyValues(values);
        elements.push((0, jsx_runtime_1.jsx)(with_collapse_1.WithCollapse, { header: (0, jsx_runtime_1.jsx)(typography_1.H2, { children: key }, void 0), body: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: days.map((_day, index) => {
                    var _a;
                    return ((0, jsx_runtime_1.jsxs)(Row, { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { onClick: getDateFns && getDateFns[index], children: days[fixDayNumber(index, startDay)] }, void 0), isProgress ? (typeof fixedValues[index] !== "object" ? ((0, jsx_runtime_1.jsx)(RowItem, { value: fixedValues[index] }, void 0)) : ((0, checkProgressValue_1.default)((_a = fixedValues[index]) === null || _a === void 0 ? void 0 : _a.status))) : ((0, jsx_runtime_1.jsx)(RowItem, { value: fixedValues[index] }, void 0))] }, key + index));
                }) }, void 0) }, key));
    }
    return elements;
};
exports.default = ({ title, valuesMap, isProgress = false, showChecklistChange = false, onLogbookClick = () => { }, onHeaderClick = () => { }, startDay, getDateFns = [() => { }] }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const days = t("time.days", { returnObjects: true });
    return ((0, jsx_runtime_1.jsxs)(ContentWrapper, { children: [showChecklistChange && ((0, jsx_runtime_1.jsx)(TableHeader_1.DisplayChecklistChangeMessage, { onLogbookClick: onLogbookClick }, void 0)), (0, jsx_runtime_1.jsx)(with_collapse_1.WithCollapse, { header: (0, jsx_runtime_1.jsx)(TableTitle_1.default, { title: title, onHeaderClick: onHeaderClick }, void 0), body: (0, jsx_runtime_1.jsx)(Body, { children: renderValues(valuesMap, days, startDay, getDateFns, isProgress) }, void 0) }, void 0)] }, void 0));
};
const ContentWrapper = styled_components_1.default.div `
  & > div > div:last-of-type {
    padding: 0;
  }

  & > div > div:first-of-type {
    padding: ${({ theme }) => theme.spacings.m};
  }
`;
const Body = styled_components_1.default.div `
  p,
  h2 {
    line-height: 1.5rem;
    margin-bottom: 0;
  }

  & > div > div:first-of-type {
    padding: ${({ theme }) => theme.spacings.m};
  }

  & > div:first-of-type {
    border-top: none;
  }

  & > div:last-of-type {
    border-bottom: none;
  }

  & > div:not(:last-of-type) {
    border-bottom: none;
  }

  & > div > div:last-of-type > div:not(:last-of-type) {
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.silverLighten40};
  }
  & > div > div:last-of-type > div {
    padding: ${({ theme }) => `${theme.spacings.xs} 0`};
  }

  & > div > div:last-of-type > div:last-of-type {
    padding-bottom: 0;
  }
`;
const Row = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
`;
const Item = styled_components_1.default.div `
  & > span {
    height: 1.5rem;
    text-align: center;
    min-width: 1.5rem;
  }
`;
//# sourceMappingURL=CollapseRecoveryMobile.js.map